<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">FaxChain 账户</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">地址和公钥</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">客户端地址格式</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">汽油和费用</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">交易</a></p>
          <div class="subAnchor">
            <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->
    
          </div>
        </div>
      </div>
      <div id="box1" class="p1">FaxChain 账户</div>
      <div class="p3">FaxChain 定义了自己的自定义Account类型，该类型使用以太坊的 ECDSA secp256k1 曲线作为密钥。这满足了完整BIP44路径的EIP84 。基于 FaxChain 的账户的根 HD 路径是 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">m/44'/60'/0'/0</span> .</div>
      <div id="box2" class="p2">地址和公钥</div>
      <div class="p3">FaxChain 默认有 3 种主要类型的 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Addresses</span> / <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">PubKeys</span> 可用：</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>帐户的地址和密钥，用于识别用户（例如 a 的发件人message）。它们是使用eth_secp256k1曲线导出的。</li>
          <li>验证器操作员的地址和密钥，用于标识验证器的操作员。它们是使用eth_secp256k1曲线导出的。</li>
          <li>共识节点的地址和密钥，用于标识参与共识的验证节点。它们是使用ed25519曲线导出的。</li>
        </ul>
      </div>
      <div id="box3" class="p2">客户端地址格式</div>
      <div class="p3"> <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">FaxChainAccounts</span> 可以用Bech32和十六进制格式表示，以实现以太坊的 Web3 工具兼容性。</div>
      <div class="p3">Bech32 格式是通过 CLI 和 REST 客户端进行 Cosmos-SDK 查询和事务的默认格式。另一方面，十六进制格式是 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">common.AddressCosmos</span> 的以太坊表示 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">sdk.AccAddress</span>。</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>地址（Bech32）： <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">ex1hcngft7gfkhn8z8fnlajzh7agyt0az0v6ztmme</span></li>
          <li>地址（EIP55十六进制）： <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">0xBE2684Afc84daf3388E99FFB215FdD4116FE89EC</span></li>
          <li>压缩公钥（Bech32）： <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">expub17weu6qepqgantzvj79rywafrxmye524tpa8kp6akjct3nw7wel623lsnfwynqyfe75k</span></li>
        </ul>
      </div>
      <div class="p3">您可以使用 FaxChain CLI 或 REST 客户端查询帐户地址：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0"># NOTE: the --output (-o) flag will define the output format in JSON or YAML (text)</div>
          <div style="padding:5px 0">exchaincli q auth account $(exchaincli keys show < MYKEY > -a) -o text</div>
          <div style="padding:5px 0">|</div>
          <div style="padding:5px 0">address: ex1hcngft7gfkhn8z8fnlajzh7agyt0az0v6ztmme</div>
          <div style="padding:5px 0">eth_address: 0xBE2684Afc84daf3388E99FFB215FdD4116FE89EC</div>
          <div style="padding:5px 0">coins:- denom: FAX</div>
          <div style="padding:5px 0">amount: "10000000"</div>
          <div style="padding:5px 0">public_key: expub17weu6qepqgantzvj79rywafrxmye524tpa8kp6akjct3nw7wel623lsnfwynqyfe75k</div>
          <div style="padding:5px 0">account_number: 0</div>
          <div style="padding:5px 0">sequence: 1</div>
          <div style="padding:5px 0">code_hash: c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470</div>
        </div>
      </div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0"># GET /auth/accounts/{address}</div>
          <div style="padding:5px 0">curl -X GET "< NODE_IP >/auth/accounts/ex1hcngft7gfkhn8z8fnlajzh7agyt0az0v6ztmme" -H "accept: application/json"</div>
        </div>
      </div>
      <div class="p3">:::tip Cosmos SDK Keyring 输出（即）仅支持 Bech32 格式的地址和公钥。::: <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">exchaincli keys</span> </div>
      <div class="p3">要使用 Web3 检索以太坊十六进制地址，请使用 JSON-RPCoec_accounts端点：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0"># query against a local node</div>
          <div style="padding:5px 0">curl -X POST --data '{"jsonrpc":"2.0","method":"eth_accounts","params":[],"id":1}' -H "Content-Type: application/json" http://localhost:26659</div>
        </div>
      </div>
      <div id="box4" class="p2">汽油和费用</div>
      <div class="p3">了解以太坊和 FaxChain 之间的 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Gas</span> 区别 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Fees</span> 。</div>
      <div class="p4">面额</div>
      <div class="p3">FaxChain 有一个公制的面额系统，用作 FAX 的单位。每个教派都有自己独特的名称（有些是在计算机科学和密码经济学的发展中发挥作用的开创性人物的姓氏）。FAX的最小面额又名基本单位称为 Wei。以下是命名面额列表及其在魏中的价值。遵循一种常见的（尽管有些模棱两可）模式，以太也指定了货币的一个单位（1e18 或 1 quintillion Wei）。</div>
      <div class="p4">先决条件阅读</div>
      <div class="p3">Gas 的概念表示在状态机上执行特定操作所需的计算量。</div>
      <div class="p3">Gas 是在以太坊上创建的，通过向系统分配少量货币价值来禁止 EVM（以太坊虚拟机）运行无限循环。EVM 上的每个操作都会消耗一个单位的 gas，通常是原生代币的一部分，并且需要用户为这些操作付费。这些操作包括状态转换，例如发送交易或调用合约。</div>
      <div class="p3">与以太坊完全一样，Cosmos 使用了 gas 的概念，这就是 Cosmos 在执行期间跟踪操作的资源使用情况的方式。Cosmos 上的操作表示为对链的存储进行的读取或写入。</div>
      <div class="p3">在 Cosmos 中，在消息执行期间会计算并向用户收取费用。该费用是根据消息执行中消耗的所有气体的总和计算得出的：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">fee = gas * gas price</div>
        </div>
      </div>
      <div class="p3">在这两个网络中，gas 用于确保操作不需要过多的计算能力来完成，并作为阻止不良用户向网络发送垃圾邮件的一种方式。</div>
      <div id="box5" class="p2">交易</div>
      <div class="p4">路由</div>
      <div class="p3">FaxChain 需要解析和处理为 EVM 和 Cosmos 中心路由的事务。我们试图通过模仿Geth 的 Transaction 结构来实现这一点，并将其视为独特的 Cosmos SDK 消息类型。以太坊交易是单个 sdk.Msg包含在 auth.StdTx. 所有相关的以太坊交易信息都包含在此消息中。这包括签名、gas、payload等。</div>
      <div class="p3">由于 FaxChain 实现了 Tendermint ABCI 应用程序接口，当交易被消费时，它们通过一系列处理程序传递。一旦这样的处理程序，AnteHandler负责执行初步的消息执行业务逻辑，例如费用支付、签名验证等。这对于 Cosmos SDK 路由交易是特定的。以太坊路由交易将绕过这一点，因为 EVM 处理相同的业务逻辑。</div>
      <div class="p3">来自 Web3 源的以太坊路由交易预计将采用RLP编码，但是 FaxChain 和 Tendermint 之间的所有内部交互都将使用一种受支持的编码格式：Protobuf和A ​​mino。</div>
      <div class="p4">交易格式</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>宇宙交易</li>
          <li>以太坊交易</li>
        </ul>
      </div>
      <div class="p4">签名</div>
      <div class="p3">FaxChain 支持EIP-155 签名。Transaction预计A将对以太坊路由交易具有单一签名。但是，就像在 Cosmos 中一样，FaxChain 将支持非以太坊交易的多个签名者。类型上的签名Transaction与以太坊相同，并且签名不会在嵌入中重复 auth.StdTx。</div>
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">FaxChain 账户</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">地址和公钥</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">客户端地址格式</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">汽油和费用</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">交易</a></p>
      <div class="subAnchor">
        <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->

      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HowToUseLedger',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>